import { Injectable } from '@angular/core';
import { AuthenticationService } from './../authentication.service';

@Injectable({
  providedIn: 'root'
})
export class UpgradeStore {
  constructor(private auth: AuthenticationService) {}

  setAccountCategory(category: string) {
    localStorage.setItem('accountCategory', category);
  }

  getAccountCategory() {
    return localStorage.getItem('accountCategory');
  }

  setAccountDocumentStatus(status: any) {
    localStorage.setItem('accountDocumentStatus', JSON.stringify(status));
  }

  getAccountDocumentStatus() {
    return JSON.parse(localStorage.getItem('accountDocumentStatus'));
  }

  setIsStatusOk(ok: boolean) {
    localStorage.setItem('isStatusOk', ok.toString());
  }

  getIsStatusOk() {
    return localStorage.getItem('isStatusOk');
  }

  setIsUpgradeInfoDismissed(dismissed: boolean) {
    localStorage.setItem('isUpgradeInfoDismissed', dismissed.toString());
  }

  getIsUpgradeInfoDismissed() {
    return localStorage.getItem('isUpgradeInfoDismissed');
  }

  setIsBusinessRegistered(registered: boolean) {
    localStorage.setItem('isBusinessRegistered', registered.toString());
  }

  getIsBusinessRegistered() {
    return localStorage.getItem('isBusinessRegistered');
  }

  setIsProceeded(proceeded: boolean) {
    localStorage.setItem('isProceeded', proceeded.toString());
  }

  getIsProceeded() {
    return localStorage.getItem('isProceeded');
  }

  setIdType(id: string) {
    localStorage.setItem('idType', id);
  }

  getIdType() {
    return localStorage.getItem('idType');
  }

  setRequestId(id: any) {
    localStorage.setItem('requestId', id.toString());
  }

  getRequestId() {
    return localStorage.getItem('requestId');
  }

  setTempSelectedIds(ids: any) {
    localStorage.setItem('tempSelectedIds', JSON.stringify(ids));
  }

  getTempSelectedIds() {
    return JSON.parse(localStorage.getItem('tempSelectedIds'));
  }

  setSelectedIds(ids: any) {
    localStorage.setItem('selectedIds', JSON.stringify(ids));
  }

  getSelectedIds() {
    return JSON.parse(localStorage.getItem('selectedIds'));
  }

  setUpgradedAccountIds(ids: any) {
    localStorage.setItem('upgradedAccountIds', JSON.stringify(ids));
  }

  getUpgradedAccountIds() {
    return JSON.parse(localStorage.getItem('upgradedAccountIds'));
  }

  getUpgradeStatus() {
    this.auth.getUpgradeStatus()
    .subscribe(
      (response: any) => {
        console.log(response);
        const upgradeStatusObject = response.AccountUpgradeStatusDTOs[0];
        const upgradeStatusArray = response.AccountUpgradeStatusDTOs;
        upgradeStatusArray.length > 0 ?
        this.setRequestId(upgradeStatusObject.AccountUpgradeRequestId) :
        this.setRequestId('null');
        this.setAccountDocumentStatus(upgradeStatusArray);
        this.setIsStatusOk(true);

        // if (upgradeStatusArray.length === 0 || (upgradeStatusObject.Status === 'Pending' ||
        // upgradeStatusObject.Status === 'In Progress')) {
        //   this.setAccountCategory('Silver');
        //   if (upgradeStatusObject.DirectorDTO.Identification) {
        //     this.setAccountCategory('Silver');
        //   }
        // } else if (upgradeStatusObject.Status === 'Approved' || upgradeStatusObject.Status === 'Declined') {
        //   if (upgradeStatusObject.Category.includes('INDIVIDUAL') || upgradeStatusObject.Category.includes('BUSINESS')) {
        //     this.setAccountCategory('Gold');
        //   } else {
        //     this.setAccountCategory('Platinum');
        //   }
        // }

        if (upgradeStatusArray.length === 0) {
          this.setAccountCategory('Silver');
        }

        if (upgradeStatusObject.Status === 'Pending' ||
            upgradeStatusObject.Status === 'In Progress' ||
            upgradeStatusObject.Status === 'Declined') {
          // if (upgradeStatusObject.Category.includes('INDIVIDUAL') || upgradeStatusObject.Category.includes('BUSINESS')) {
            if (upgradeStatusObject.Passport || (!upgradeStatusObject.Passport && upgradeStatusObject.DirectorDTO.Identification)) {
              this.setAccountCategory('Silver');
            } else if (upgradeStatusObject.Passport && upgradeStatusObject.DirectorDTO.Identification) {
              this.setAccountCategory('Gold');
            } else {
              this.setAccountCategory('Silver');
            }
          // } else {
          //   this.setAccountCategory('Silver');
          // }
        }

        if (upgradeStatusObject.Status === 'Approved') {
          if (upgradeStatusObject.Category.includes('INDIVIDUAL') || upgradeStatusObject.Category.includes('BUSINESS')) {
            if (upgradeStatusObject.Passport) {
              this.setAccountCategory('Gold');
            }
          } else {
            this.setAccountCategory('Platinum');
          }
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  getUpgradeAccountIds() {
    this.auth.getUpgradeAccountIds()
    .subscribe(
      (response: any) => {
      console.log(response);
      this.setUpgradedAccountIds(response.AccountIds);
    },
      (error) => {
      console.log(error);
    });
  }
}
